import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Alert, Form, Icon, Steps } from 'antd'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import SignupForm from './SignupForm'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { signup as actionSignup, finishSignup } from '../../redux-flow/actions/signup'
import CookieConsentComponent from '../../Components/CookieConsent'
import './signup.css'
import { ReactComponent as  SmsStar } from '../../images/sms-star.svg'
import theme from '../../config/theme'

class Cadastro extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
          email: '',
          referralCode: ''
        };
      }

    componentDidMount = async () => {
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
        
        // Get referral code from URL if present
        const referralCode = new URLSearchParams(window.location.search).get('referralCode');
        if (referralCode) {
            this.setState({ referralCode });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    onChangeEmail = (e) => {
        this.setState({ email: e.target.value })
    }

    render() {
        const { currentStep, handleSubmit, finishSignup, isLoading, message, logged } = this.props
        return (
            <div id="sectionContato">
            <Navbar fillBackground={this.state.fillBackground} />
            {logged && currentStep === 1 ? <Redirect to="/minhaconta" /> : (
                <div className="section headerWrapper cadastroWrapper pb-0">
                    <Container  className="h-100">
                        <Row className="h-100" style={{ display: currentStep === 1 ? 'flex' : 'none' }}>
                            <Col md={6} className="d-flex flex-column justify-content-center p-0 pr-5 signUpCall">
                                <h2 className="pageCall text-white text-left mt-5">Leva <span style={{ color: theme.colors.primary }}>minutos</span> para abrir a sua conta.</h2>
                                <h4 className="text-left">
                                Preencha suas informações ao lado e <span>comece</span> sua <span style={{ color: theme.colors.primary }}>jornada</span>.
                                </h4>
                            </Col>
                            <Col md={6} className="p-0 pl-5 signUpForm">
                                <div className="cadastroFormWrapper">
                                <div className="contentWrapper">
                                    <div>
                                        <div className="feedbackWrapper">
                                            {message && <Form.Item>
                                                <Alert message={message} type="error" showIcon />
                                            </Form.Item>}

                                        </div>

                                        <div
                                            style={{ display: currentStep === 1 ? 'block' : 'none' }}
                                        >
                                            <SignupForm 
                                                handleSubmit={handleSubmit} 
                                                disabled={isLoading} 
                                                onChangeEmail={this.onChangeEmail}
                                                referralCode={this.state.referralCode} 
                                            />
                                        </div>

                                        
                                    </div>
                                </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="h-100" style={{ display: currentStep === 2 ? 'flex' : 'none' }}>
                            <Col lg={12} xl={12} md={12} className="d-flex flex-column align-items-center w-100 m-0 text-center text-white">
                                    <h2 className="pageCall text-white mt-5">Confirme seu email</h2>
                                    <SmsStar className="iconeRegistro" />
                                    <p>Enviamos um email de confirmação para o email</p>
                                    <h3 className="emailRegistro" style={{ color: theme.colors.primary }}>{this.state.email}</h3>
                                    <p className="textRegistro">Você está a um passo de fazer parte da revolução da economia como conhecemos.</p>
                                    <p className="textRegistro">Por favor confirme seu endereço de email clicando no link que enviamos e se prepare para sua jornada ao futuro.</p>
                                    
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}
            <CookieConsentComponent />
            <Footer />
        </div>
        )
    }
}

const mapStateToProps = state => ({
    currentStep: state.signup.stepNumber,
    isLoading: state.signup.isLoading,
    message: state.signup.logMessage,
    logged: state.login.logged
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: form => e => {
        e.preventDefault()
        window.scrollTo(0, 190)
        dispatch(actionSignup(form))
    },
    finishSignup: () => dispatch(finishSignup())
})

export default connect(mapStateToProps, mapDispatchToProps)(Cadastro)